<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Generar Albarán</h4>
				</div>
				<div class="modal-body">
					<template v-if="data">
						<template v-if="products">
							<template v-if="products.length">
								<div class="table-responsive">
									<table class="table table-hover table-striped table-condensed">
										<thead>
											<tr>
												<th>
													<div class="checkbox checkbox-success">
														<input type="checkbox" v-model="selectAll">
														<label style="padding-left: 0px;"></label>
													</div>
												</th>
												<th>{{ $platform.setting.number_symbol }}</th>
												<th>Ref.</th>
												<th>Título</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="product in products">
												<td>
													<div class="checkbox checkbox-success">
														<input type="checkbox" :value="product.id" v-model="item.product_storages_id">
														<label></label>
													</div>
												</td>
												<td>
													{{ product.product_id }}
												</td>
												<td>
													{{ product.reference }}
												</td>
												<td>{{ product.title }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</template>
							<template v-else>
								No hay productos para entregar...
							</template>
						</template>
					</template>
				</div>
				<div class="modal-footer">
					<button @click="store" v-if="item.product_storages_id.length > 0" type="button" class="btn btn-success">Generar</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-order-delivery-notes'
				},
				loading: false,
				products: null,

				item: {
					order_id: this.data.id,
					product_storages_id: [],
				}
			}
		},
		computed: {
			selectAll: {
				get: function () {
					return this.products ? this.item.product_storages_id.length == this.products.length : false;
				},
				set: function (value) {
					var product_storages_id = [];

					if (value) {
						this.products.forEach(function (product) {
							product_storages_id.push(product.id);
						});
					}

					this.item.product_storages_id = product_storages_id;
				}
			}
		},
		methods: {
			open() {
				this.loadProducts()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.$emit('reload')
			},
			loadProducts() {
				var products = null
				if(this.data) {
					if(this.data.products) {
						if(this.data.products.length) {
							products = this.data.products.filter(function(product) {
								if(!product.product_delivery_note_storage) {
									return product
								}
							})
						}
					}
				}
				this.products = products
				this.checked()
			},
			checked() {
				var product_storages_id = []
				if(this.products) {
					if(this.products.length) {
						this.products.forEach(function(product) {
							product_storages_id.push(product.id)
						})
					}
				}
				this.item.product_storages_id = product_storages_id
			},
			store() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: 'Se generará un albarán para este pedido',
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/delivery/notes', that.item)
							.then(response => {
								that.close()
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/orders/views/AddDeliveryNotes.vue